export default "__VITE_ASSET__CC8mDDWu__"